export default __webpack_public_path__ + "static/baecea54-cfd3-4578-8717-abf89eba62b6-50da46507340b544f3c25ada23d465e5.woff";